import type React from "react";
import { Input } from "src/components/ui/input";
import { Label } from "src/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import { sanitizeBrlValue } from "src/utils/functions";

interface FinancingStepFormProps {
  valorImovel: string;
  setValorImovel: (v: string) => void;
  entrada: string;
  setEntrada: (v: string) => void;
  custos: string;
  setCustos: (v: string) => void;
  dataInicioFinanciamento: string;
  setDataInicioFinanciamento: (v: string) => void;
  prazo: string;
  setPrazo: (v: string) => void;
  taxaAnual: string;
  setTaxaAnual: (v: string) => void;
  sistemaAmortizacao: string;
  setSistemaAmortizacao: (v: string) => void;
}

export const FinancingStepForm: React.FC<FinancingStepFormProps> = ({
  valorImovel,
  setValorImovel,
  entrada,
  setEntrada,
  custos,
  setCustos,
  dataInicioFinanciamento,
  setDataInicioFinanciamento,
  prazo,
  setPrazo,
  taxaAnual,
  setTaxaAnual,
  sistemaAmortizacao,
  setSistemaAmortizacao,
}) => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 animate-in fade-in slide-in-from-left-4 duration-300">
      <div className="grid gap-2">
        <Label htmlFor="valorImovel">Valor do imóvel (R$)</Label>
        <div className="relative">
          <Input
            id="valorImovel"
            type="text"
            placeholder="500.000,00"
            value={valorImovel}
            onChange={(e) => setValorImovel(sanitizeBrlValue(e))}
          />
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="entrada">Entrada (R$)</Label>
        <div className="relative">
          <Input
            id="entrada"
            type="text"
            placeholder="100.000,00"
            value={entrada}
            onChange={(e) => setEntrada(sanitizeBrlValue(e))}
          />
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="custos">Custos do financiamento (R$)</Label>
        <div className="relative">
          <Input
            id="custos"
            type="text"
            placeholder="15.000,00"
            value={custos}
            onChange={(e) => setCustos(sanitizeBrlValue(e))}
          />
        </div>
      </div>

      <div className="grid gap-2">
        <Label htmlFor="prazo">Prazo (meses)</Label>
        <div className="relative">
          <Input
            id="prazo"
            type="text"
            placeholder="360"
            className="pr-14"
            value={prazo}
            onChange={(e) => setPrazo(e.target.value)}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
            meses
          </span>
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="taxaAnual">Taxa anual (%)</Label>
        <div className="relative">
          <Input
            id="taxaAnual"
            type="text"
            placeholder="7,00"
            className="pr-8"
            value={taxaAnual}
            onChange={(e) => setTaxaAnual(sanitizeBrlValue(e))}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
            %
          </span>
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="amortizacao">Sistema de Amortização</Label>
        <Select
          value={sistemaAmortizacao}
          onValueChange={setSistemaAmortizacao}
        >
          <SelectTrigger id="amortizacao">
            <SelectValue placeholder="Selecione o tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="0">SAC (Parcelas decrescentes)</SelectItem>
            <SelectItem value="1">Price (Parcelas fixas)</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
